import React, { Component } from 'react';
import { MDBContainer } from 'mdbreact';
import './HomePage.css';

export default class HomePage extends Component {         
    render () {         
        return (
            <MDBContainer>
                <h4 className="orange-text text-center">2Bad Software</h4>
                Welcome to 2Bad Software      
            </MDBContainer>
        );
  }
}